import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    Form,
    Input,
    Select,
    Modal,
    Typography,
    Button,
    DatePicker,
    notification,
    TimePicker,
    Alert,
} from "antd";
import moment from "moment";
import ProductApi from "../../Apis/ProductApi";
import dayjs from "dayjs";
import AftreCookApi from "../../Apis/AftreCookApi";
import { AudioOutlined, InfoCircleFilled, LoadingOutlined } from "@ant-design/icons";

const { Title } = Typography;
function AddTemp({ visible, onClose, ProductDetails, AfterID }) {
    const [formAdd] = Form.useForm();
    const navigate = useNavigate();
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    console.log(ProductDetails)
    formAdd.setFieldsValue({
        productId: ProductDetails?.recipeDTO?.recipeName,
        batchCode: ProductDetails?.batchCode,
        OUBD: dayjs(ProductDetails?.productionCreateDate),
        SellDate: dayjs(ProductDetails?.sellByDate),
        prodTime: dayjs(ProductDetails?.cookingTime, 'HH:mm'),
    });
    // const [Products, setProducts] = React.useState([]);
    // const getProducts = useCallback(() => {
    //     ProductApi.Listproducts()
    //         .then((response) => {
    //             setProducts(response?.payloadDto);
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         });
    // }, []);


    // useEffect(() => {
    //     getProducts();
    // }, [getProducts]);

    const handleSubmit = (data) => {

        const inputDate = new Date(data?.prodTime);
        const hours = inputDate.getHours().toString().padStart(2, '0');
        const minutes = inputDate.getMinutes().toString().padStart(2, '0');

        const formattedTime = `${hours}:${minutes}`;


        const SelectDate = dayjs(data.createDate).format("DD/MM/YYYY");
        const sellDate = dayjs(data.SellDate).format("DD/MM/YYYY");
        let formData = JSON.stringify({
            dateOfCooking: ProductDetails?.productionCreateDate,
            timeOfCookingFinished: formattedTime,
            temperatureOfTheProductAfterCook: data.Temperature,
            batchCodeOfTheCookedProduct: ProductDetails?.batchCode,
            newSellByDateOfTheCookedProduct: convertToUnixTimestamp(sellDate),
            description: Correctvalid ? data.CorrectiveAction : "",
            oubd: AfterID?.oubd,
            quantityOfTheCookedProduct: ProductDetails?.recipeDTO?.quantity,
            temp: data.Temperature,
            unit: ProductDetails?.unit,
            productionDTO: {
                id: ProductDetails?.id,
                institutionDTO: { id: ProductDetails?.institutionDTO?.id, },
            },
            institutionDTO: {
                id: ProductDetails?.institutionDTO?.id,
            },
            tenantDTO: {
                id: decodedToken?.tenantId,
                tenantApiKey: decodedToken?.tenantApiKey,
            },
        });
        console.log(formData)
        AftreCookApi.UpdateafterCook(AfterID?.id, formData)
            .then((response) => {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Created</span>,
                    description: "Updated Successfully",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            })
            .catch((err) => {
                console.log(err);
                // Error Notification
                if (err.apiError.status) {
                    notification.open({
                        message: (
                            <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
                        ),
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });
    };

    function convertToUnixTimestamp(dateString) {
        const parts = dateString.split("/");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);

        const unixTimestamp = Date.UTC(year, month, day);
        return unixTimestamp;
    }
    const currentDate = moment().format("DD/MM/YYYY");


    const handleCancel = () => {
        formAdd.resetFields();
        onClose();
    };

    const handleInput = (e) => {
        const value = e.target.value;
        if (/^\d*\.?\d{0,2}$/.test(value)) {
            e.target.value = value;
        } else {
            // Remove any non-numeric or extra decimal characters
            e.target.value = value.slice(0, -1);
        }
    };


    const [Correctvalid, setCorrectvalid] = useState(false);
    const handleInputChange = (event) => {
        const newItem = event.target.value.trim();
        if (newItem < 75) {
            setCorrectvalid(true)
        } else {
            setCorrectvalid(false)
        }

    };
    const [isRecording, setIsRecording] = useState(false);
    const startRecording = (fieldN) => {

        const recognition = new window.webkitSpeechRecognition();
        recognition.lang = 'en-US';
        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            let fieldName = fieldN;
            if (transcript < 75) {
                setCorrectvalid(true)
            } else {
                setCorrectvalid(false)
            }
            formAdd.setFieldsValue({
                [fieldName]: transcript,
            });
        };

        recognition.start();
        if (fieldN === 'Temperature') {
            setIsRecording(true);
        }
    };

    const stopRecording = () => {
        setIsRecording(false);
    };
    return (
        <>
            <Modal
                footer={[]}
                width={600}
                visible={visible}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    Take Temperature
                </Title>
                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 15,
                    }}
                    className="FormClass IndividualProduct-Model"
                    onFinish={handleSubmit}
                >
                    <>

                        <div className="Ingrefiant-form">
                            <Form.Item
                                name="productId"
                                label="Product Description :"
                                className="text-lable"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter Product Description.",
                                    },
                                ]}
                            >
                                <Input
                                    type="text"
                                    readOnly
                                    placeholder="Batch Code"
                                    className="control-input"
                                />
                            </Form.Item>
                        </div>

                        <Form.Item
                            name="batchCode"
                            label="Batch Code"
                            className="text-lable"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter Batch Code.",
                                },
                            ]}
                        >
                            <Input
                                type="text"
                                readOnly
                                placeholder="Batch Code"
                                className="control-input"
                            />
                        </Form.Item>

                        <Form.Item
                            name="OUBD"
                            label="Product Made On"
                            className="text-lable disabled  pt-3"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select OUBD.",
                                },
                            ]}
                        >
                            <DatePicker
                                disabled
                                format={"DD/MM/YYYY"}
                                className="form-control control-input"
                            />
                        </Form.Item>
                        <Form.Item
                            name="SellDate"
                            label="Sell By Date"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter Sell By Date",
                                },
                            ]}
                        >
                            <DatePicker
                                disabled
                                format={"DD/MM/YYYY"}
                                className="form-control control-input"
                            />
                        </Form.Item>
                        <Form.Item
                            name="prodTime"
                            label="Time Of Cooking Finished"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please select Time Of Cooking Finished",
                                },
                            ]}
                        >
                            <TimePicker disabled use12Hours format="h:mm a" className="form-control control-input" />
                        </Form.Item>
                        <Form.Item
                            name="Temperature"
                            label="Temperature"
                            className="text-lable"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter Temperature.",
                                },
                            ]}
                        >
                            <Input
                                type="number"
                                onChange={(event) => handleInputChange(event)}
                                placeholder="0"
                                className="control-input col-6"
                                style={{
                                    border: 'none',
                                    textAlign: 'end',
                                    padding: '0px'
                                }}
                                addonAfter={
                                    <>
                                        <Button
                                            className="StockTempClass"
                                            style={{
                                                border: 'none',
                                                padding: 0,
                                                paddingTop: '0px',
                                                margin: 0,
                                                background: 'none',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            'C
                                        </Button>
                                        <Button
                                            onMouseDown={() => startRecording('Temperature')}
                                            onMouseUp={stopRecording}
                                            onMouseLeave={stopRecording}
                                            style={{
                                                border: 'none',
                                                padding: 0,
                                                margin: 0,
                                                marginLeft: '10px',
                                                paddingLeft: '5px',
                                                paddingBottom: '5px',
                                                background: 'none',
                                                borderRadius: '0px',
                                                borderLeft: '1px solid #d9d9d9',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {isRecording ? <LoadingOutlined /> : <AudioOutlined />}
                                        </Button>
                                    </>
                                }
                            />
                        </Form.Item>
                        {/* <p style={{ textAlign: 'center', fontSize: '13px', color: 'blue' }}  ><InfoCircleFilled style={{ fontSize: '9px' }} className="inforIcon" />Temperature should be above 75℃</p> */}
                        <Alert message="Temperature should be above 75℃" type="info" className="temp-info-text" />
                        <Form.Item
                            name="CorrectiveAction"
                            label="Corrective Action"
                            className={Correctvalid ? 'text-lable' : 'd-none'}
                            rules={Correctvalid ? [
                                {
                                    required: true,
                                    message: "Please enter Temperature.",
                                },
                            ] : []}
                        >
                            <Input
                                type="text"
                                placeholder="Corrective Action"
                                className="control-input"
                            />
                        </Form.Item>



                        {/* <div className="d-flex justify-content-center pt-4">
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="btn btn-primary btn-save mx-2"
                                style={{ width: "37%" }}
                            >
                                Update
                            </Button>
                            <Link
                                type="primary"
                                to={""}
                                className="btn btn-primary btn-back mx-2 w-20"
                                style={{ width: "37%" }}
                                onClick={handleCancel}
                            >
                                Cancel
                            </Link>
                        </div> */}
                        <div
                            className="d-flex justify-content-between pt-4"
                            style={{
                                gap: "10px",
                            }}
                        >
                            <Button
                                onClick={handleCancel}
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#000",
                                    textDecoration: "none",
                                    fontWeight: 500,
                                }}
                            >
                                Cancel
                            </Button>

                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                    fontWeight: 500,
                                }}
                            >
                                Save Temperature
                            </Button>
                        </div>
                    </>
                </Form>
            </Modal>
        </>
    );
}

export default AddTemp;
